import Title from "@/components/base/Title";
import { Box } from "@mui/system";

const Header = () => {
  return (
    <Box
      sx={{
        mt: 5,
      }}
    >
      <Title>👩🏻‍💻 예원의 유튜브 강의실 👨🏻‍💻</Title>
    </Box>
  );
};

export default Header;
